/* ============================================================
   VIVĀRA — Shared ingredient explorer
   ------------------------------------------------------------
   ONE interaction system consumed by index.html and product.html.
   Reads window.VIVARA_INGREDIENTS (single source of truth).

   Desktop : dynamic image left · continuous list centre · detail right
   Mobile  : the same continuous list becomes an accordion; the image
             and detail nodes are MOVED (not duplicated) beneath the
             active ingredient, so there is only ever one copy in DOM.

   Hover / focus previews · click locks · 320ms crossfade · no layout shift.
   ============================================================ */
(function () {
  "本ポリシーはVIVĀRAで直接ご注文いただいた場合に適用され、お客様の法律上の権利を妨げるものではありません。";

  var MOBILE = window.matchMedia("(max-width: 900px)");

  function build(root) {
    var data = window.VIVARA_INGREDIENTS;
    if (!root || !data || !data.length) return;

    var listEl = root.querySelector("[data-ing-list]");
    var visualEl = root.querySelector("[data-ing-visual]");
    var detailEl = root.querySelector("[data-ing-detail]");
    var visualHome = root.querySelector("[data-ing-visual-home]");
    var detailHome = root.querySelector("[data-ing-detail-home]");
    if (!listEl || !visualEl || !detailEl) return;

    /* ---- crossfade layers ---- */
    var layers = [document.createElement("img"), document.createElement("img")];
    layers.forEach(function (img, i) {
      img.className = "ing-layer" + (i === 0 ? " is-on" : "");
      img.decoding = "async";
      img.width = 900;
      img.height = 900;
      visualEl.appendChild(img);
    });
    var front = 0;

    /* ---- list ---- */
    var items = data.map(function (ing, i) {
      var li = document.createElement("li");
      li.className = "ing-item";

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ing-btn";
      btn.id = "ing-btn-" + i;
      btn.setAttribute("aria-controls", "ing-detail-panel");

      var bullet = document.createElement("span");
      bullet.className = "ing-bullet";
      bullet.setAttribute("aria-hidden", "true");

      var label = document.createElement("span");
      label.className = "ing-name";
      label.textContent = ing.name;

      btn.appendChild(bullet);
      btn.appendChild(label);
      if (ing.alt) {
        var alt = document.createElement("em");
        alt.className = "ing-alt";
        alt.textContent = "(" + ing.alt + ")";
        btn.appendChild(alt);
      }

      var slot = document.createElement("div");
      slot.className = "ing-slot";

      li.appendChild(btn);
      li.appendChild(slot);
      listEl.appendChild(li);

      return { li: li, btn: btn, slot: slot, data: ing, index: i };
    });

    var locked = 0;
    var shown = -1;

    function paintDetail(ing) {
      detailEl.innerHTML = "";

      if (ing.group) {
        var group = document.createElement("p");
        group.className = "ing-group";
        group.textContent = ing.group;
        detailEl.appendChild(group);
      }

      var name = document.createElement("p");
      name.className = "ing-detail-name";
      name.textContent = ing.name + (ing.alt ? " — " + ing.alt : "");
      detailEl.appendChild(name);

      if (ing.body) {
        var body = document.createElement("p");
        body.className = "ing-detail-body";
        body.textContent = ing.body;
        detailEl.appendChild(body);
      }

      /* `tradition` is factual context. `benefit` is never rendered —
         see js/claims.js. */
      if (ing.tradition) {
        var tLabel = document.createElement("p");
        tLabel.className = "ing-detail-label";
        tLabel.textContent = "処方の中で";
        detailEl.appendChild(tLabel);

        var trad = document.createElement("p");
        trad.className = "ing-detail-benefit";
        trad.textContent = ing.tradition;
        detailEl.appendChild(trad);
      }
    }

    function show(index) {
      if (index === shown) return;
      var ing = data[index];

      // crossfade
      var next = 1 - front;
      var nextLayer = layers[next];
      var apply = function () {
        layers[front].classList.remove("is-on");
        nextLayer.classList.add("is-on");
        front = next;
      };
      nextLayer.alt = ing.imageAlt || "";
      if (ing.imageAlt) nextLayer.removeAttribute("aria-hidden");
      else nextLayer.setAttribute("aria-hidden", "true");

      if (nextLayer.getAttribute("src") === ing.image) {
        apply();
      } else {
        nextLayer.onload = apply;
        nextLayer.onerror = apply;
        nextLayer.src = ing.image;
      }

      visualEl.classList.toggle("is-placeholder", !!ing.placeholder);
      paintDetail(ing);
      shown = index;
    }

    function setActive(index) {
      items.forEach(function (it, i) {
        var on = i === index;
        it.li.classList.toggle("is-active", on);
        if (on) it.btn.setAttribute("aria-current", "true");
        else it.btn.removeAttribute("aria-current");
        if (MOBILE.matches) it.btn.setAttribute("aria-expanded", on ? "true" : "false");
      });
      show(index);
      if (MOBILE.matches) placeMobile(index);
    }

    /* ---- responsive node placement (move, never duplicate) ---- */
    function placeMobile(index) {
      var slot = items[index].slot;
      if (visualEl.parentNode !== slot) slot.appendChild(visualEl);
      if (detailEl.parentNode !== slot) slot.appendChild(detailEl);
    }

    function placeDesktop() {
      if (visualHome && visualEl.parentNode !== visualHome) visualHome.appendChild(visualEl);
      if (detailHome && detailEl.parentNode !== detailHome) detailHome.appendChild(detailEl);
      items.forEach(function (it) {
        it.btn.removeAttribute("aria-expanded");
      });
    }

    function applyMode() {
      if (MOBILE.matches) {
        placeMobile(locked);
        items.forEach(function (it, i) {
          it.btn.setAttribute("aria-expanded", i === locked ? "true" : "false");
        });
      } else {
        placeDesktop();
      }
    }

    /* ---- events ---- */
    items.forEach(function (it) {
      // hover / focus previews on desktop only (never the sole access path)
      it.btn.addEventListener("mouseenter", function () {
        if (!MOBILE.matches) setActive(it.index);
      });
      it.btn.addEventListener("focus", function () {
        if (!MOBILE.matches) setActive(it.index);
      });
      it.btn.addEventListener("click", function () {
        if (MOBILE.matches && locked === it.index) {
          // second tap collapses on mobile
          it.li.classList.remove("is-active");
          it.btn.setAttribute("aria-expanded", "false");
          if (visualEl.parentNode) visualEl.parentNode.removeChild(visualEl);
          if (detailEl.parentNode) detailEl.parentNode.removeChild(detailEl);
          locked = -1;
          return;
        }
        locked = it.index;
        setActive(it.index);
      });
    });

    // leaving the list restores the locked selection
    listEl.addEventListener("mouseleave", function () {
      if (!MOBILE.matches && locked >= 0) setActive(locked);
    });

    if (MOBILE.addEventListener) MOBILE.addEventListener("change", applyMode);
    else if (MOBILE.addListener) MOBILE.addListener(applyMode);

    detailEl.id = "ing-detail-panel";
    setActive(0);
    applyMode();

    /* formulation philosophy line from the shared data module
       (the note sits outside the explorer root, so fall back to document) */
    var note = root.querySelector("[data-ing-note]") ||
               (root.closest("section") || document).querySelector("[data-ing-note]");
    if (note && window.VIVARA_FORMULATION_NOTE) {
      note.textContent = window.VIVARA_FORMULATION_NOTE;
    }
  }

  function init() {
    document.querySelectorAll("[data-ingredients]").forEach(build);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
